import {USER_EVENTS} from '../../../../events/events';
import BaseComponent from '../../../../base/base_component';
import Model from './sweden_responsible_gaming_icons_model';
import {ICON_TYPE_CSS_SELECTOR} from './sweden_responsible_gaming_consts';
import {NAVIGATION_VIEWS} from "../../../external_links/external_links_consts";
let view = require('./view/sweden_responsible_gaming_icons.html');

export default class SwedenResponsibleGamingIconsController extends BaseComponent {
    static CLASS = 'SwedenResponsibleGamingIconsController';

    _model = null;


    init(params) {
        super.init(params);
        this._params = params;
        this._model = Model.create(params);
    }

    start() {
        let bakedHTML = this.bake(view, {
            iconTypeClass: ICON_TYPE_CSS_SELECTOR[this._model.getIconType()]
        });
        this.setHTML(bakedHTML);
        this._subscribe();
    }


    _subscribe() {
        // no longer opens cashier on panic button click
        this.onDOMEvent(this.getDOMElementByClassName('cgp-themes-sw-resp-game-panic'), USER_EVENTS.ON_CLICK, () => {
            this._sendAnalytics('panic_click');
            this.serviceFactory.regulationService().getRegulation().openSelfExclusion(NAVIGATION_VIEWS.WINDOW);
        });

        // open my account on limits button click
        this.onDOMEvent(this.getDOMElementByClassName('cgp-themes-sw-resp-game-limit'), USER_EVENTS.ON_CLICK, () => {
            this._sendAnalytics('deposit_limits_click');
            this.serviceFactory.regulationService().getRegulation().openLimits();
        });

        // open self test link on self test button click
        this.onDOMEvent(this.getDOMElementByClassName('cgp-themes-sw-resp-game-self-test'), USER_EVENTS.ON_CLICK, () => {
            this._sendAnalytics('self_test_click');
            this.serviceFactory.structuredLoggingService().getLogger({
                eventName: 'SelfTestClicked',
            }).setTarget('project-sweden-selftest').info();
            this.serviceFactory.regulationService().getRegulation().openSelfTest(NAVIGATION_VIEWS.WINDOW);
        });
    }


    _sendAnalytics(label) {
        this.serviceFactory.analyticsService().sendClickstreamEvent(
            {
                eventName:'Orbit_User_Flow',
                category:'Navigation',
                action: 'Header',
                label:'Icon_' + label
            });
    }
}